import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchProgressOverview } from '../../api/progressOverviewGraphApi';

// Async thunk for fetching the data
export const getProgressOverview = createAsyncThunk(
  'progress/getProgressOverview',
  async (payload, { rejectWithValue }) => {
    try {
      const data = await fetchProgressOverview(payload);
      
      // Transform the API response here
      const transformedData = data.map((item) => ({
        value: item.track_Value,
        date: item.track_Date,
      }));

      return transformedData;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Initial state of the slice
const initialState = {
  data: [],
  loading: false,
  error: null,
};

// Creating the slice
const progressSlice = createSlice({
  name: 'progress',
  initialState,
  reducers: {
    // Add any local reducers if necessary
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProgressOverview.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProgressOverview.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; // Now the payload will have the transformed data
        state.error = null;
      })
      .addCase(getProgressOverview.rejected, (state, action) => {
        state.loading = true;
        state.error = action.payload || 'Failed to fetch progress overview data';
      });
  },
});

export default progressSlice.reducer;